import 'dayjs/locale/id';
import React from 'react';
import Select from '../../fields/SelectBox/Select';
import IconUpDownArrow from '../../icons/IconUpDownArrow';
import styles from './styles.scoped.css';

export const initialValues = {
  regional: '',
  provinceId: '',
  cityId: ''
};

export const Fields = ({
  values = initialValues,
  handleChangeValues,
  handleSearchFilter,
  dropdownData,
  regionalId,
  // provinceId,
  // cityId,
  // cities
}) => {

  return [
    {
      label: 'Regional',
      disabled: regionalId !== '',
      component: (
        <Select
          data={dropdownData.regional}
          eventName="regional"
          hideLabel
          name="regional"
          onChangeSelect={(value) =>
            handleChangeValues({ name: 'regional', value })
          }
          placeholder="Pilih Regional"
          rightSection={<IconUpDownArrow />}
          valueForm={values.regional || regionalId}
        />
      ),
    },
    {
      label: 'Provinsi',
      // disabled: provinceId !== '',
      component: (
        <Select
          className={styles.cusFilterField}
          data={dropdownData.provinces}
          eventName="provinces"
          hideLabel
          name="provinceId"
          onChangeSelect={(value) =>
            handleChangeValues({ name: 'provinceId', value })
          }
          placeholder="Pilih Provinsi"
          rightSection={<IconUpDownArrow />}
          valueForm={values.provinceId}
        />
      ),
    },
    {
      label: 'Kota/Kab',
      // disabled: JSON.stringify(cities)?.length === 40,
      component: (
        <Select
          className={styles.cusFilterField}
          data={dropdownData.cities}
          debounce={true}
          eventName="cities"
          hideLabel
          name="cityId"
          onChangeSelect={(value) =>
            handleChangeValues({ name: 'cityId', value })
          }
          onSearchChange={handleSearchFilter}
          placeholder="Pilih Kota/Kab"
          rightSection={<IconUpDownArrow />}
          searchable={true}
          valueForm={values.cityId}
        />
      ),
    }
  ];
};
